import { saveAs } from 'file-saver';

import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

const CONTENT_TYPE_MAPPING = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
};

export function fetchCSVExportForEdit(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.CSV_EXPORT });
}


export function deleteCSVExport(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.CSV_EXPORT
  });
}


export function saveCSVExport(app, dataToSave) {
  const { data = {} } = dataToSave;
  const csvExportData = {
    doc_type: DocType.CSV_EXPORT,
    name: util.toStringText( data.name ),
    record_type: util.toStringText( data.record_type ),
    template: util.toStringText( data.template ),
    filters: data.filters,
    fields: data.fields,
    query: data.query,
    highlights: data.highlights,
    sorting: data.sorting,
    compare_filters: data.compare_filters,
    graphs: data.graphs,
    enable_graphs: util.toBoolean(data.enable_graphs),
    having_query: data.having_query,
  };
  return common.saveDoc(app, {
    source: data,
    doc: csvExportData
  });
}


export function fetchCSVExportById(app, params) {
  const { id } = params;
  return common.getDoc(app, { id, docType: DocType.CSV_EXPORT });
}


export async function exportCsvRecord(app, params) {
  const { id, filters, query, sorting, export_type } = params;

  if (id) {
    const service = app.service('csv_export/execute/' + id);
    const data = await service.create(
      {
        filters,
        query,
        sorting,
      },
      {
        export_type,
      }
    );

    return data;
  } else {
    throw new Error('CSV export record ID is not available');
  }
}

export async function previewSearchRecord(app, params) {
  const service = app.service('csv-export/preview');
  const data = await service.create(params);
  return data;
}

export async function downloadExport({
  api_access_token,
  api_host_url,
  fileName,
  subType,
}) {
  const res = await fetch(`${api_host_url}/csv-export/download/${fileName}`, {
    method: 'GET',
    headers: {
      'Content-Type': CONTENT_TYPE_MAPPING[subType],
      'Authorization': `Bearer ${api_access_token}`,
    },
  });

  const blob = await res.blob();
  saveAs(blob, fileName);
}

export async function fetchSearchRecordDropdown(app, params) {
  const { searchTerm, id } = params;
  const dropdown_type = 'csv_export/dropdown';
  const query = {
    id,
    dropdown_type,
    searchTerm,
    methodType: 'post',
  };

  return common.getDropdownList(app, { query });
}
